import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import Switch from 'src/common/primitives/Switch';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

import { GeolocationSearch } from './geolocations/management/GeolocationSearch';
import {
  setShowArchivedGeolocations,
  setShowGeolocationModal,
  setShowTagsModal,
  setTagSearchTerm,
  settingSlice,
} from './setting.slice';
import { TRIP_REQUEST_EMBED_KB_URL } from './trip-request-form/constants';

export function SettingsRouteActions() {
  return (
    <Routes>
      <Route index element={<></>} />
      <Route path="tags" element={<TagRouteActions />} />
      <Route path="geolocations" element={<GeolocationRouteActions />} />
      <Route
        path="trip-request-form"
        element={<TripRequestFormRouteActions />}
      />
    </Routes>
  );
}

export function TagRouteActions() {
  const dispatch = useDispatch();
  const tagSearchTerm = useAppSelector((state) => state.setting.tagSearchTerm);

  const { inputValue, handleInputChange } = useDebouncedSearch(
    setTagSearchTerm,
    tagSearchTerm
  );

  return (
    <div className="flex items-center gap-4">
      <SearchTypeahead
        dataTestId="tags-search"
        onChange={handleInputChange}
        placeholder="Search tags"
        value={inputValue}
      />
      <Button
        onClick={() => dispatch(setShowTagsModal(true))}
        variant="primary"
      >
        Add a Tag
      </Button>
    </div>
  );
}

export function GeolocationRouteActions() {
  const dispatch = useDispatch();
  const { showArchivedGeolocations } = useAppSelector((state) => state.setting);

  return (
    <>
      <div className="flex text-sm" style={{ height: '80%' }}>
        <label className="flex items-center gap-2">
          <Switch
            label="Show archived geolocations"
            inputProps={{
              value: showArchivedGeolocations,
              onChange: (nextValue: boolean) => {
                dispatch(setShowArchivedGeolocations(nextValue));
              },
            }}
          />
          Include archived
        </label>
      </div>
      <GeolocationSearch />
      <Button
        onClick={() => dispatch(setShowGeolocationModal(true))}
        variant="primary"
      >
        Add a Geolocation
      </Button>
    </>
  );
}

export function TripRequestFormRouteActions() {
  const dispatch = useAppDispatch();
  return (
    <div className="flex flex-row items-center justify-end gap-4">
      <p className="text-sm text-gray-500">
        Need help?{' '}
        <a
          href={TRIP_REQUEST_EMBED_KB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-600 underline underline-offset-2 hover:text-indigo-500"
        >
          View our setup guide
        </a>
      </p>
      <Button
        variant="primary"
        onClick={() => {
          dispatch(settingSlice.actions.createTripRequestEmbed());
        }}
      >
        Add a Trip Request Embed
      </Button>
    </div>
  );
}
